import { BLOCK_COMMANDS } from './block';
import { DIMENSION_COMMANDS } from './dimension';
import { DRAW_COMMANDS } from './draw';
import { INQUIRY_COMMANDS } from './inquiry';
import { MODIFY_COMMANDS } from './modify';
import type { Command } from './types';

/**
 * 명령 레지스트리 (작업지시서 P2-05 / P2-14)
 *
 * 이름과 별칭으로 명령을 찾는다. 별칭은 AutoCAD 기본 단축 명령을 그대로 쓴다 —
 * 손이 기억하는 것을 바꾸면 기존 사용자가 즉시 이탈한다.
 */

export const ALL_COMMANDS: Command[] = [
  ...DRAW_COMMANDS,
  ...MODIFY_COMMANDS,
  ...BLOCK_COMMANDS,
  ...DIMENSION_COMMANDS,
  ...INQUIRY_COMMANDS,
];

const byName = new Map<string, Command>();
for (const c of ALL_COMMANDS) {
  byName.set(c.name.toUpperCase(), c);
  for (const a of c.aliases) {
    const key = a.toUpperCase();
    if (byName.has(key) && byName.get(key)!.name !== c.name) {
      // 개발 중 별칭이 겹치면 조용히 덮어쓰지 말고 드러낸다.
      console.warn(`[cad] 별칭 충돌: '${a}' — ${byName.get(key)!.name} vs ${c.name}`);
    }
    byName.set(key, c);
  }
}

/** 정확한 이름 또는 별칭으로 찾기 */
export function findCommand(input: string): Command | null {
  return byName.get(input.trim().toUpperCase()) ?? null;
}

/** 명령행 자동완성 후보 */
export function completeCommand(prefix: string): Command[] {
  const p = prefix.trim().toUpperCase();
  if (p === '') return [];

  const seen = new Set<string>();
  const out: Command[] = [];

  // 별칭 정확 일치를 최우선으로 (L → LINE)
  const exact = byName.get(p);
  if (exact) {
    out.push(exact);
    seen.add(exact.name);
  }

  for (const c of ALL_COMMANDS) {
    if (seen.has(c.name)) continue;
    if (c.name.startsWith(p) || c.aliases.some((a) => a.toUpperCase().startsWith(p))) {
      out.push(c);
      seen.add(c.name);
    }
  }
  return out.slice(0, 8);
}

/** 리본/툴바 구성 */
export const COMMAND_GROUPS: { title: string; commands: Command[] }[] = [
  { title: '그리기', commands: DRAW_COMMANDS },
  { title: '편집', commands: MODIFY_COMMANDS },
  { title: '블록', commands: BLOCK_COMMANDS },
  { title: '치수', commands: DIMENSION_COMMANDS },
  { title: '조회', commands: INQUIRY_COMMANDS },
];
